export const styles = {
  productWraper: {
    display: 'flex',
    flexWrap: 'wrap'
  }
}
